import { useAccount, useConnect, useDisconnect, useWalletClient } from 'wagmi';
import { goerli, mainnet, polygon } from 'wagmi/chains';

import { Web3Chains, Web3WagmiConnectors } from '@pkg/providers/Web3Provider/types';
import { getConnector } from '@pkg/providers/Web3Provider/utilities';

import config from '@app/config';

export const useWalletConnect = () => {
    const { connectAsync: wagmiConnectAsync, connectors } = useConnect();
    const { disconnectAsync } = useDisconnect();

    const { address, isConnected, connector } = useAccount();
    const walletClient = useWalletClient();

    const connectAsync = async (type: Web3WagmiConnectors, blockchain: Web3Chains = Web3Chains.Ethereum) => {
        try {
            let account: string;

            let chain: number;
            switch (blockchain) {
                case Web3Chains.Ethereum:
                    chain = config.nodeEnv === 'production' ? mainnet.id : goerli.id;
                    break;
                case Web3Chains.Polygon:
                    chain = polygon.id;
                    break;
                default:
                    chain = mainnet.id;
                    break;
            }

            if (type === Web3WagmiConnectors.Metamask) {
                const result = await wagmiConnectAsync({
                    connector: getConnector(connectors, Web3WagmiConnectors.Metamask),
                    chainId: chain,
                });
                account = result.account;
            } else if (type === Web3WagmiConnectors.Ledger) {
                const result = await wagmiConnectAsync({
                    connector: getConnector(connectors, Web3WagmiConnectors.Ledger),
                    chainId: chain,
                });
                account = result.account;
            } else {
                const result = await wagmiConnectAsync({
                    connector: getConnector(connectors, Web3WagmiConnectors.WalletConnect),
                });
                account = result.account;
            }
            return account;
        } catch {
            return '';
        }
    };

    return {
        connectAsync,
        connector,
        currentAccount: address?.toLowerCase(),
        disconnectAsync,
        isConnected: isConnected,
        walletClient,
    };
};
